import React from 'react';
import {connect} from 'react-redux';
import Translate, {plainTranslate} from '../common/translate';
import SingleCheckbox from './singleCheckbox.jsx';
import { Form, Input, Button } from 'antd';

class StorageSettings extends React.Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);

        this.state = {
              value: null
        };
  }
 
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.state.value == null) {
            this.setState({
                value: this.props.value
            }, function () {
                this.formRef.current.setFieldsValue(this.state.value)
            });
        }
    }

  onFinish = (values) => {
          this.props.onSave(values);        
  }  

  onSubmit = () => {
    this.formRef.current.submit()
  }

    render() {
        
        return (
                <React.Fragment>
                    <div className="row m-bot15">
                        <div className="col-lg-12">
                                <Form 
                                  layout="vertical"
                                 ref={this.formRef}
                                 onFinish={this.onFinish}
                                 className="company-settings-form">
                                    <div className="col-lg-12"> 
                                        <br />
                                        <div className="col-lg-6">
                                            <Form.Item 
                                            name="bucketName"
                                            label={plainTranslate(this.props.settings.locale, 'Bucket Name')}>
                                              <Input placeholder={plainTranslate(this.props.settings.locale, 'Bucket Name')}/>                                           
                                            </Form.Item>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Item 
                                            name="accountId"
                                            label={plainTranslate(this.props.settings.locale, 'Account Id')}>
                                                      <Input placeholder={plainTranslate(this.props.settings.locale, 'Account Id')}/>
                                               </Form.Item>
                                        </div>
                                        <div className="col-lg-6">
                                          <Form.Item 
                                            name="accountAccessKey"
                                            label={plainTranslate(this.props.settings.locale, 'Account access key')}>
                                           <Input placeholder={plainTranslate(this.props.settings.locale, 'Account access key')}/>
                                            </Form.Item>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Item 
                                            name="accountSecretKey"
                                            label={plainTranslate(this.props.settings.locale, 'Account secret key')}>
                                           <Input placeholder={plainTranslate(this.props.settings.locale, 'Account secret key')}/>
                                              </Form.Item>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Item 
                                            name="storageUrl"
                                            label={plainTranslate(this.props.settings.locale, 'Storage URL')}>
                                                    <Input placeholder={plainTranslate(this.props.settings.locale, 'Storage URL')}/>
                                              </Form.Item>
                                        </div>
                                    </div>
                                    <Button
                                    type="primary" 
                                    htmlType="button" 
                                    onClick={this.onSubmit}
                                    className="button-primary">
                                    {plainTranslate(this.props.settings.locale, 'Save')}
                                   </Button>
                                    
                                   </Form>
                        </div>
                    </div>
                </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    settings: state.settings
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StorageSettings);